import { useTranslation } from "react-i18next"

import FileUploader from "@/components/FileUploader"
import Icon from "@/components/Icon"
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table"

type Props = {
  isDisabled: boolean
  onFileSelect: (file: File) => Promise<void>
}

export function StepPickFile({ isDisabled, onFileSelect }: Props) {
  const { t } = useTranslation()

  async function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
    const file = e.target.files?.[0]
    if (file) {
      await onFileSelect(file)
    }
  }

  return (
    <div className="flex flex-col gap-y-6">
      <div className="flex flex-col gap-y-2">
        <h3 className="font-bold">
          {t("noCallList.importCSV.formatCard.title")}
        </h3>
        <p className="text-sm text-neutral-500">
          {t("noCallList.importCSV.formatCard.description")}
        </p>
        <div className="rounded-sm border-x border-t">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="bg-neutral-200">
                  {t("noCallList.importCSV.columns.phone")}
                </TableHead>
                <TableHead className="bg-neutral-200">
                  {t("noCallList.importCSV.columns.email")}
                </TableHead>
                <TableHead className="bg-neutral-200">
                  {t("noCallList.importCSV.columns.noCall")}
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              <TableRow>
                <TableCell className="text-neutral-500">
                  090-1234-5678
                </TableCell>
                <TableCell className="text-neutral-500">
                  user@example.com
                </TableCell>
                <TableCell className="text-neutral-500">true</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
        <a
          href="/templates/ng_list_template.csv"
          download
          className="
            flex items-center gap-x-2 text-sm font-bold text-primary-400
          "
        >
          {t("noCallList.importCSV.formatCard.downloadTemplate")}{" "}
          <Icon name="download" />
        </a>
      </div>

      <div className="flex flex-col gap-y-2">
        <h3 className="font-bold">{t("noCallList.importCSV.step3")}</h3>
        <FileUploader
          accept=".csv"
          disabled={isDisabled}
          className="mt-2"
          onUpload={handleFileChange}
          placeholder={t("entries.upload.noFilePlaceholder")}
        />
      </div>
    </div>
  )
}
